import { DecimalPipe, PercentPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ClTooltip } from '@corelabs/angular/ui';

export interface BarRow {
    id: string;
    name: string;
    count: number;
    /** The bar's tooltip. */
    label: string;
}

@Component({
    selector: 'app-bar-list',
    templateUrl: './bar-list.component.html',
    styleUrl: './bar-list.component.css',
    imports: [DecimalPipe, PercentPipe, ClTooltip],
})
export class BarListComponent {
    /** Most first — the leader sets the scale. */
    readonly rows = input.required<BarRow[]>();
    /** Adds each row's share of this total. */
    readonly total = input<number>();

    protected readonly max = computed(() => this.rows()[0].count);
}
